/*
 * File: /src/router/routes/admin.js
 * Created Date: Tuesday August 27th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 27th August 2019 10:21:36 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

const AccountList = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/AccountList.vue');

const AccountEdit = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/AccountEdit.vue');

const AccountView = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/AccountView.vue');

const AccountAgency = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/AccountAgency.vue');

const UserAdd = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/UserAdd.vue');

const UserEdit = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/UserEdit.vue');

export const adminRoutes = [
  {
    path: 'accounts/',
    name: 'List all accounts',
    component: AccountList
  },
  {
    path: 'accounts/:id(\\d+)/',
    name: 'Viewing Account',
    component: AccountView
  },
  {
    path: 'accounts/:id(\\d+)/edit/',
    name: 'Edit Account',
    component: AccountEdit
  },
  {
    path: 'accounts/:id(\\d+)/agency/',
    name: 'Account Agency Settings',
    component: AccountAgency
  },
  {
    path: 'accounts/:id(\\d+)/user/add/',
    name: 'Adding user',
    component: UserAdd
  },
  {
    path: 'accounts/:id(\\d+)/user/edit/:userId(\\d+)/',
    name: 'Editing user',
    component: UserEdit
  }
];
